import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_FBM_INSTALL = createAsyncActionTypes('FETCH_FBM_INSTALL');